export const MerchantLogoStyles = {
  logo: 'mr-4'
}
